$(function() {
  const url = new URL(window.location.href);
  const urlParams = url.searchParams;

  const signUp = urlParams.get('sign_up');
  const source = urlParams.get('source');

  if (signUp === 'success' && source) {
    dataLayer.push({
      event: 'sign_up',
      sign_up_flow: source
    });

    window.ElevarDataLayerHelper?.pushSignUp({ sign_up_flow: source });

    urlParams.delete('sign_up');
    urlParams.delete('source');
    const newUrl = url.toString();

    window.history.replaceState({}, document.title, newUrl);
  }
})
